import React, { useEffect, useState } from 'react';
import './AdCartsToys.css';
import axios from 'axios';
import AdProduct from './AdProduct';
import icondelete from './img/icons/icons8-remove-100.png';
import iconadd from './img/icons/icons8-add-new-100.png';
import iconsearch from './img/icons/search.png';
import { useHistory } from 'react-router-dom';
import { useStateValue } from './StateProvider';

function AdCartsToys() {
    const [{ admnavagationoption }, dispatch] = useStateValue();
    const [product, setProduct] = useState([]);
    const [productadmin, setProductadmin] = useState([]);
    const [input, setInput] = useState('');
    const [pagIndex, setPagIndex] = useState(1);
    const [number_of_pag, setNumber_of_pag] = useState('');
    const [previous, setPrevious] = useState(1);
    const [next, setNext] = useState(1);
    var setPag = 1;
    var results_per_pag = 18;
    const [active, setActive] = useState(true);
    const history = useHistory();

    const hadd = () => {
        
        dispatch({
            type: 'SET_ADMNO',
            admnavagationoption: 'two'
        })

        setActive(!active);
        history.push('/admin-new-product');
    }

    useEffect(() => {
        axios
            .get('https://toycityzimbabwe.com/backend/getProduct.php')
            .then((res) => {
                number_of_results(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, []);

    function number_of_results(results){
        var number_of_result = results.length;
        var number_of_pag = Math.ceil(number_of_result/results_per_pag);
        setNumber_of_pag(number_of_pag)
    }
    
    const moveDot = index => {
        setPagIndex(index)
        setPag = index;
        setNext(index);
        setPrevious(index);
    }

    useEffect(() => {

        setPag = pagIndex;

        axios
            .get('https://toycityzimbabwe.com/backend/getAllProductAdmin.php', {params :{setPag, results_per_pag}})
            .then((res) => {
                setProduct(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, [pagIndex])


    useEffect(() => {

        setPag = pagIndex;

        axios
            .get('https://toycityzimbabwe.com/backend/getAllProductAdmin.php', {params :{setPag, results_per_pag}})
            .then((res) => {
                setProduct(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, [admnavagationoption])

    useEffect(() => {
        axios
            .get('https://toycityzimbabwe.com/backend/getProductAdmin.php')
            .then((res) => {
                setProductadmin(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, []);


    let data =  productadmin.filter(item => {
        return Object.keys(item).some(key => 
            item[key].toString().toLowerCase().includes(input.toString().toLowerCase())
            )
    })
    


    return (
        <div className='adcartstoys cartss'>
            <div className='device__search'>
                <i><img src={iconsearch} alt='search'/></i>
                <input onChange={e => setInput(e.target.value)} type='text' placeholder='Search Device' />
            </div>
            <div className="carts__cartrow">                
                <div className="carts__carts">
                    <button onClick={hadd}>
                        {
                            <img src={iconadd} alt='iconadd' />
                        }
                    </button>
                    {
                        data.map(item => (
                            <AdProduct 
                                id = {item.id}
                                title={item.name}
                                price={item.price} 
                                img={item.img}
                                searching_words={item.searching_words}
                                sold={item.sold}
                            />
                        ))
                    }
                </div>
                <div className='carts__pag'>
                    {(number_of_pag === 0 || previous === 1) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(previous - 1)}
                            className='carts__btn'
                        >
                            Previous
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 ) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next)}
                            className='carts__btn active'
                        >
                            {next}
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 || number_of_pag === next) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 1)}
                            className='carts__btn'
                        >
                            {next + 1}
                        </button>  
                    )}

                    {(number_of_pag === 0 || next === 0 || (number_of_pag - 1) === next || number_of_pag === next) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 2)}
                            className='carts__btn'
                        >
                            {next + 2}
                        </button>  
                    )}

                    {(number_of_pag === 0 || number_of_pag === next) ? ' ' : (
                        
                        <button
                            onClick={() => moveDot(next + 1)}
                            className='carts__btn'
                        >
                            Next
                        </button>  
                    )}
                </div>
            </div>
        </div>
    )
}

export default AdCartsToys;